module.exports = __webpack_public_path__ + "static/media/mheg.7ab934c1.jpg";